import { useLocation, useParams } from 'react-router-dom';

import { useTenantIdFromParams } from '@eluve/session-helpers';

import { useIsOrganizationRoute } from './useIsOrganizationRoute';

const basePath = `/output-templates`;

export const useOutputTemplateRoutePath = () => {
  const tenantId = useTenantIdFromParams();
  const { outputTemplateId } = useParams() as {
    outputTemplateId?: string;
    variantNumber?: string;
  };

  const location = useLocation();
  const isAdminRoute = location.pathname.includes('/admin/');
  const isOrganizationRoute = useIsOrganizationRoute();

  let outputTemplateBasePath = basePath;

  if (isAdminRoute) {
    outputTemplateBasePath = `/admin${basePath}`;
  } else if (isOrganizationRoute) {
    outputTemplateBasePath = `/organizations/${tenantId}/settings/templates`;
  }

  const cloneBasePath = `${outputTemplateBasePath}/clone/${outputTemplateId}`;

  const createCloneOutputVariantPath = (variantNumber: number) =>
    `${cloneBasePath}/variant/${variantNumber}`;

  const createEditVariantPath = (variantNumber: number) =>
    `${outputTemplateBasePath}/edit/${outputTemplateId}/variant/${variantNumber}`;

  return {
    outputTemplateBasePath,
    createCloneOutputVariantPath,
    createEditVariantPath,
  };
};
